import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import {
  Container,
  StickyTableHeadCell,
  TableContainer,
  TableHeadCell,
  TableBodyRow,
  StickyTableBodyCell,
  TableBodyCell,
} from '../Leaderboard.styles';
import useLeaderboardStore from '../../../store/zustand/useLeaderboardStore';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonElement = styled.div`
  width: 80%;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 2.5s infinite;
  border-radius: 4px;
  margin: 0 auto;
`;

const LeaderboardSkeleton: React.FC = () => {
  const { leaderboardFilters } = useLeaderboardStore();
  // Create mock data for 10 rows
  const mockRows = Array(leaderboardFilters?.limit || 10).fill(null);
  const mockColumns = Array(5).fill(null); // Rank, Name, and 3 KPI columns

  return (
    <Container>
      <TableContainer>
        <thead>
          <tr style={{ backgroundColor: '#ff6a00' }}>
            {mockColumns.map((_, index) => {
              if (index < 2) {
                return (
                  <StickyTableHeadCell
                    key={`header-${index}`}
                    left={index === 0 ? 0 : 80}
                  >
                    <SkeletonElement />
                  </StickyTableHeadCell>
                );
              }
              return (
                <TableHeadCell key={`header-${index}`}>
                  <SkeletonElement />
                </TableHeadCell>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {mockRows.map((_, rowIndex) => (
            <TableBodyRow key={`row-${rowIndex}`}>
              {mockColumns.map((_, cellIndex) => {
                if (cellIndex < 2) {
                  return (
                    <StickyTableBodyCell
                      key={`cell-${rowIndex}-${cellIndex}`}
                      left={cellIndex === 0 ? 0 : 80}
                      isEven={rowIndex % 2 === 0}
                    >
                      <SkeletonElement />
                    </StickyTableBodyCell>
                  );
                }
                return (
                  <TableBodyCell key={`cell-${rowIndex}-${cellIndex}`}>
                    <SkeletonElement />
                  </TableBodyCell>
                );
              })}
            </TableBodyRow>
          ))}
        </tbody>
      </TableContainer>
    </Container>
  );
};

export default LeaderboardSkeleton;
